<template>
  <Course />
</template>

<script lang="ts">
import { clearStorage } from "@/utils/user-store.util";
import { defineAsyncComponent, defineComponent } from "vue";

const Course = defineAsyncComponent(
  () => import("@/views/Course/CourseHome/course-home.vue")
);

export default defineComponent({
  name: "dashboardAdm",
  components: { Course },
  methods: {
    logoutUser(): void {
      clearStorage();
      this.$router.push({ name: "sign-in" });
    },
  },
});
</script>
